import React, { Component, Fragment } from 'react';
// import CompanyIcon from '../assets/images/companylogo'
import logo from '../../assets/images/oneroof-logo.svg';
import Axios from '../../services/services';
import { withRouter, Link } from 'react-router-dom';
import './Header.css'
import UserIcon from '../../assets/images/userIcon'
import BellIcon from '../../assets/images/bellIcon'
import ProfileIcon from '../../assets/images/profileIcon'
import PowerIcon from '../../assets/images/powerIcon'

import AdminIcon from '../../assets/images/adminIcon'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown'
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import CloseIcon from '@material-ui/icons/Close';
import PersonIcon from '@material-ui/icons/Person';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import IconButton from '@material-ui/core/IconButton';

import MenuIcon from '@material-ui/icons/Menu';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import CircularProgress from '@material-ui/core/CircularProgress';
import FacebookSignIn from '../Users/User/FacebookSignIn'
import Tab from 'react-bootstrap/Tab'

import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';

const baseUrl = process.env.PUBLIC_URL;
class Header extends Component {
    _isMounted = false

    state = {
        setSearchShow: false,
        setNavShow: false,
        meunIndex: 0,
        loading: true,
        onScroll: false,
        data: [],
        searchValue: "",
        search: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Search',
            elementConfig: {
                maxLength: 100,
            },
            type: "text",
            name: 'code',
            value: '',
            validation: {
                type: 'text',
                required: true,
            },
            classname: '',
            color: '#212529',
        },
        onScroll: false,
    }

    constructor(props) {
        super(props);
        this._isMounted = true
        console.log(this.props.isAuthenticated)
        this.headerPosition = React.createRef()
    }

    toggleMenu = () => {

        this.setState({
            setNavShow: !this.state.setNavShow
        })

    }

    handleOverMenu = () => {

        this.setState({
            setMenuIndex: 1,
            setNavShow: true
        })

    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true)
        Axios.navServices.getMainNav()
            .then(response => {
                this.setState({
                    data: response.data.data,
                    loading: false,
                })
            })
            .catch(error => {

            })

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = () => {

        var inner = document.getElementById('root')
        if (inner.scrollTop > 100) {
            this.setState({ onScroll: true });
        }
        else {
            this.setState({ onScroll: false });
        }

    }

    handleShowSearch = () => {
        this.setState({
            setSearchShow: !this.state.setSearchShow
        })
    }

    handleChange = (event, name) => {

        event.preventDefault();
        const updatedSearch = {
            ...this.state.search,
            search: {
                value: event.target.value
            }
        };

        this.setState({ search: updatedSearch });

    };

    handleURL = (category, slug) => {
        this.props.history.push({
            pathname: `${baseUrl}/products/${category}/${slug}`,
        })
    }

    handleLogin = () => {
        this.props.history.push({
            pathname: `${baseUrl}/login/`
        })
    }

    handleCartURL = () => {
        this.props.history.push({
            pathname: `${baseUrl}/carts`,
        })
    }

    handleMouseOver = (e, index) => {
        e.preventDefault()
        this.setState({ meunIndex: index })
    }

    render() {
        const {
            onScroll,
            setSearchShow,
            search,
            data,
            loading,
            meunIndex,
            setNavShow } = this.state

        let mainBar = ''
        let searchBar = ''
        let searchTxt = ''

        if (setSearchShow) {
            mainBar = 'd-none'
            searchBar = 'd-block elementToFadeInAndOut'
        } else {
            mainBar = ''
            searchBar = 'd-none m-fadeOut'

        }

        return (
            <Fragment>
                <Navbar className={onScroll ? mainBar + " light-bg fixed-top" : mainBar + " light-bg"} >
                    <Container className="justify-content-between desktop-menu">
                        <Navbar.Brand href="/"><img src={logo} alt="oneroof" className="company-logo" /></Navbar.Brand>
                        <Nav className="mr-auto">
                            <div className="furniture nav-link pl-4" onMouseOver={this.props.SubMenuMouseOver}>
                                Furniture
                            <div className="mega-menu shadow">
                                    <Container>
                                        <Row className="w-100">
                                            <Tab.Container id="left-tabs-example" defaultActiveKey="0">
                                                <Col sm={3}>

                                                    {loading ?

                                                        <Row className="mt-4">
                                                            <Col md={11} className="text-center">
                                                                <CircularProgress size={100} />
                                                            </Col>
                                                        </Row>
                                                        :
                                                        data.map((d, i) => (
                                                            <Nav.Item key={i} >
                                                                <Nav.Link className="p-0" onMouseOver={(e) => this.handleMouseOver(e, i)}>{d.category_slug}</Nav.Link>
                                                            </Nav.Item>
                                                        ))
                                                    }

                                                </Col>
                                                <Col sm={7}>

                                                    {
                                                        data.map((data, i) => (
                                                            <Row md={12} key={i} className={i == meunIndex ? 'showMenu' : 'd-none'}>
                                                                {  data.sub_category.map((d, index) => (
                                                                    <Col key={index} md={4}>
                                                                        {/* <a a href={baseUrl+"/products/"+category+"/"+slug} onClick={()=>this.handleURL(data.category_slug, d.slug)}>{d.title}</a> */}
                                                                        <a onClick={() => this.handleURL(data.category_slug, d.slug)}>{d.title}</a>

                                                                    </Col>
                                                                ))
                                                                }
                                                            </Row>

                                                        ))
                                                    }

                                                </Col>
                                            </Tab.Container>
                                        </Row>
                                    </Container>


                                </div>

                            </div>
                            <Nav.Link href="">Accessories</Nav.Link>
                            <Nav.Link href="">Tips</Nav.Link>
                            <Nav.Link href="/contactus">Contact Us</Nav.Link>


                        </Nav>
                        <div >
                            <SearchIcon fontSize="small" style={{ color: "#45AFA9" }} className="mr-3 clickable icon" onClick={this.handleShowSearch} />
                            <PersonIcon fontSize="small" style={{ color: "#45AFA9" }} className="mr-3 clickable icon" onClick={() => this.handleLogin()} />
                            <Button variant="contained" color="primary" className="btn-primary">
                                <ShoppingBasketIcon fontSize="small" style={{ color: "#ffffff" }} onClick={() => this.handleCartURL()} />
                                {this.props.totalQty > 0  && this.props.isAuthenticated && <span className="badge shopcart-badge">{this.props.totalQty}</span>}
                            </Button>
                        </div>

                    </Container >
                    <Container className="justify-content-between mobile-menu">
                        <Navbar.Brand href="/"><img src={logo} alt="oneroof" className="company-logo" /></Navbar.Brand>
                        <Nav className="ml-auto">
                            <MenuIcon width={15} height={15} onClick={this.toggleMenu} />
                        </Nav>
                        <SwipeableDrawer
                            anchor={"right"}
                            open={setNavShow}
                            onClose={this.toggleMenu}
                            onOpen={this.toggleMenu}
                        >
                            <div className="mobile">testing</div>
                        </SwipeableDrawer>
                    </Container>
                </Navbar>
                <Navbar className={searchBar}>
                    <Container className="d-flex justify-content-between">
                        <Nav className={searchTxt + " mr-auto ml-auto col-md-6"}>
                            <IconButton aria-label="menu">
                                <SearchIcon fontSize="small" style={{ color: "#45AFA9" }} />
                            </IconButton>
                            <InputBase
                                className="input-full-width"
                                placeholder="Search Products...d"
                                inputProps={{ 'aria-label': 'Search..' }}
                            />
                            <IconButton type="submit" aria-label="search" onClick={this.handleShowSearch}>
                                <CloseIcon />
                            </IconButton>


                        </Nav>
                    </Container>

                </Navbar>
            </Fragment>
        )
    }
}
const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        facebookUrl: state.auth.facebookUrl,
        totalQty: state.product.totalQty


    };
};
const mapDispatchToProps = (dispatch) => ({
    showModal: (name) => dispatch(actions.modalShow(name)),
    onFetchCart:() => dispatch(actions.getAllCartService())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))